import React from "react";
import { SerializedStyles } from "@emotion/react";
import cn from "classnames";

import { css } from "@emotion/react";
import styled from "@emotion/styled";

import { CSS_MQ } from "../../../styles/breakpoints";
import { ReactTFC } from "../../../utils/fp/missing-ts-parts";

export const TwoColumnGrid: ReactTFC<{
  ratio: [number, number] | [string, string];
  columnGap?: number;
  container: string | undefined;
  atLeast: "md" | "none";
  attachStyles?: SerializedStyles;
  children: React.ReactNode;
  className?: string;
}> = props => {
  return (
    <StyledGridDiv
      ratio={props.ratio}
      columnGap={props.columnGap}
      atLeast={props.atLeast}
      className={cn({ container: !!props.container }, `at-least-${props.atLeast}`, props.className)}
      css={css`
        ${props.attachStyles};

        &.container {
          max-width: var(${props.container});
          width: 100%;

          margin-left: auto;
          margin-right: auto;
        }
      `}
    >
      {props.children}
    </StyledGridDiv>
  );
};

const StyledGridDiv = styled.div<{
  ratio: [number, number] | [string, string];
  columnGap?: number;
  atLeast: "none" | "md";
}>`
  &.at-least-none {
    display: grid;
    grid-auto-columns: 1fr;
    grid-auto-flow: column;

    grid-column-gap: ${props => (props.columnGap ? `${props.columnGap}px` : undefined)};

    grid-template-columns: ${({ ratio: [leftColumn, rightColumn] }) =>
      `minmax(0, ${inject(leftColumn)}) minmax(0, ${inject(rightColumn)})`};
  }

  &.at-least-md {
    ${CSS_MQ.atLeastMd} {
      display: grid;
      grid-auto-columns: 1fr;
      grid-auto-flow: column;

      grid-column-gap: ${props => (props.columnGap ? `${props.columnGap}px` : undefined)};

      grid-template-columns: ${({ ratio: [leftColumn, rightColumn] }) =>
        `minmax(0, ${inject(leftColumn)}) minmax(0, ${inject(rightColumn)})`};
    }
  }
`;

function inject(n: number | string) {
  return typeof n === "number" ? `${n}fr` : `var(${n})`;
}
